import { render, staticRenderFns } from "./AtCamp.vue?vue&type=template&id=10d1b59a&scoped=true&"
import script from "./AtCamp.vue?vue&type=script&lang=tsx&"
export * from "./AtCamp.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d1b59a",
  null
  
)

export default component.exports